import React from "react";
import { LoadingSpinner } from "./loadingSpinner";
import { cn } from "@/lib/utils";

interface PageLoadingProps {
  message?: string;
  className?: string;
}

export const PageLoading: React.FC<PageLoadingProps> = ({
  message,
  className,
}) => {
  return (
    <div
      className={cn(
        "min-h-screen bg-background text-foreground flex items-center justify-center",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <LoadingSpinner size="lg" />
        {message && <p className="text-lg text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
};
